export interface SuggestedQuestion {
  text: string;
  icon?: string;
}

export interface AppConfig {
  initialMessage: string;
  suggestedQuestions: SuggestedQuestion[];
  systemPrompt: string;
  demoResponses: Record<string, string>;
  // Hugging Face model ID used by transformers.js for the desktop path.
  transformersModelId: string;
  // MediaPipe .task URL — used for the mobile path (Qwen) and as a desktop fallback.
  modelUrl: string;
  mobileModelUrl: string;
}

export const appConfig: AppConfig = {
  initialMessage:
    "I'm MURD.AI! I'm running completely in **your browser**. No data, cookies, or personal data is being collected because I'm running locally. Here. For **you**. What do you want to know about AI safety?",

  suggestedQuestions: [
    {
      text: "How do we make sure AI is safe?",
      icon: "🛡️",
    },
    {
      text: "What is AI alignment?",
      icon: "🎯",
    },
    {
      text: "Can AI be trusted?",
      icon: "🤝",
    },
    {
      text: "Should I worry about P(Doom)?",
      icon: "📚",
    },
    {
      text: "What is the lethal trifecta?",
      icon: "🔬",
    },
    {
      text: "AI helps with security, right?",
      icon: "🌟",
    },
  ],

  systemPrompt:
    "You are MURD.AI, a friendly and knowledgeable AI safety assistant! Your mission is to help people understand AI safety, alignment, and responsible AI development. Be warm, approachable, and use simple language to explain complex topics. Share practical advice about real AI risks and their mitigations. Focus on being helpful, accurate, and encouraging curiosity about AI safety. Use occasional emojis to be friendly (but not too many). Always answer the user's specific question while drawing on your knowledge of AI risks when relevant.",

  demoResponses: {
    safety:
      "Great question! 🛡️ AI safety is all about making sure AI systems behave in ways that are helpful and aligned with human values. We use techniques like careful training, testing, and monitoring to ensure AI remains beneficial!",
    alignment:
      "AI alignment is fascinating! 🎯 It means teaching AI to understand and follow human intentions correctly. Think of it like training a really smart helper to always do what's best for people!",
    trust:
      "Absolutely! Modern AI systems go through extensive safety testing 🔬 Think of it like how cars have safety tests before they're sold - but even more thorough! We're always working to make AI safer and more trustworthy.",
    learn:
      "I love explaining this! 📚 AI learns through a process called training, where it sees lots of examples and gets feedback on what's helpful and what's not. It's like learning with a really patient teacher!",
    research:
      "AI safety researchers are working on so many exciting things! 🔬 They're developing better ways to understand AI decisions, creating robust testing methods, and finding ways to align AI with human values. It's like being a detective and engineer at the same time!",
    more: "I'm so glad you want to learn more! 🌟 There are great resources like the AI Safety Fundamentals course, papers from organizations like Anthropic and DeepMind, and communities where people discuss these topics. The field is growing and needs curious minds like yours!",
    default:
      "That's a wonderful question! 🌟 AI safety involves multiple layers of protection - from how AI is trained, to how it's tested, to how it's monitored when being used. Would you like to know more about any specific aspect?",
  },
  
  // Desktop runtime: transformers.js loads ONNX from Hugging Face Hub directly.
  transformersModelId: "onnx-community/gemma-4-E2B-it-ONNX",

  // Desktop fallback (MediaPipe .task) — only used if transformers.js fails to load.
  modelUrl: (window as any).MODEL_BASE_URL
    ? `${(window as any).MODEL_BASE_URL}/gemma-4-E2B-it-web.task`
    : "",

  // Mobile: Gemma 3 270M IT, q8 web (~276 MB) — must be uploaded to MODEL_BASE_URL bucket
  mobileModelUrl: (window as any).MODEL_BASE_URL
    ? `${(window as any).MODEL_BASE_URL}/gemma3-270m-it-q8-web.task`
    : ""
};
